import { Component, signal, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { LayoutComponent } from './components/layout/layout';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LayoutComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal(environment.title);

  constructor(private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle(environment.title);
  }
}
